import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Card, Dropdown, Image, Table } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import seller from 'assets/img/e-learning/avatar/rsaldarriaga.png';
import CardDropdown from 'components/common/CardDropdown';
import SoftBadge from 'components/common/SoftBadge';
import IconGroup from 'components/common/icon/IconGroup';
import { bgWhiteIcons } from 'data/socialIcons';
import PropTypes from 'prop-types';

const StudentInfo = ({ data }) => {
 return (
  <Card className="font-sans-serif">
   <Card.Body className="d-flex gap-3 flex-column flex-sm-row align-items-center">
    <Image fluid width={130} className="rounded-2" src={seller} alt="student profile image" />
    <Table borderless className="fs--1 fw-medium mb-0">
     <tbody>
      <tr>
       <td className="p-1 pt-4" style={{ width: '35%' }}>
        Redes Sociales:
       </td>
       <tr>
        <IconGroup className="mt-3 justify-content-center  " icons={bgWhiteIcons} />
       </tr>
      </tr>
      <tr>
       <td className="p-2" style={{ width: '35%' }}>
        Email:
       </td>
       <td className="p-2">
        <Link to="mailto:goodguy@nicemail.com" className="text-600">
         {data.email}
        </Link>
        <SoftBadge bg="success" pill className="d-none d-md-inline-block ms-2">
         Verificado
         <FontAwesomeIcon icon="check" className="ms-1" />
        </SoftBadge>
       </td>
      </tr>
      <tr>
       <td className="p-1" style={{ width: '35%' }}>
        Móvil:
       </td>
       <td className="p-1">
        {!data.private ? (
         <>
          <Link to="!#" className="text-600">
           {data.phone}
          </Link>
          <SoftBadge bg="primary" pill className="d-none d-md-inline-block ms-2">
           verificación de 2 pasos
           <FontAwesomeIcon icon="link" className="ms-1" />
          </SoftBadge>
         </>
        ) : (
         <p>Privado</p>
        )}
       </td>
      </tr>
     </tbody>
    </Table>
    <div className="position-absolute top-0 end-0 m-3">
     <CardDropdown iconClassName="fs--1" drop="bottom">
      <div className="py-2">
       <Dropdown.Item href="#!">Ver perfil</Dropdown.Item>
       <Dropdown.Item href="#!">Contratar</Dropdown.Item>
       <Dropdown.Divider as="div" />
       <Dropdown.Item href="#!" className="text-danger">
        Reportar
       </Dropdown.Item>
      </div>
     </CardDropdown>
    </div>
   </Card.Body>
  </Card>
 );
};

StudentInfo.propTypes = { data: PropTypes.object.isRequired };

export default StudentInfo;
